import React from 'react';
import { AnimatePresence } from 'motion/react';
import { LoginModal, RegisterModal } from './auth-modals/index.js';

interface AuthModalsProps {
  isLoginOpen: boolean;
  isRegisterOpen: boolean;
  onCloseLogin: () => void;
  onCloseRegister: () => void;
  onOpenRegister: () => void;
  onOpenLogin: () => void;
  onLoginSuccess?: () => void;
}

export const AuthModals: React.FC<AuthModalsProps> = ({
  isLoginOpen,
  isRegisterOpen,
  onCloseLogin,
  onCloseRegister,
  onOpenRegister,
  onOpenLogin,
  onLoginSuccess,
}) => {
  return (
    <AnimatePresence>
      {/* Login Modal */}
      {isLoginOpen && (
        <LoginModal
          isOpen={isLoginOpen}
          onClose={onCloseLogin}
          onOpenRegister={onOpenRegister}
          onLoginSuccess={onLoginSuccess}
        />
      )}

      {/* Register Modal */}
      {isRegisterOpen && (
        <RegisterModal
          isOpen={isRegisterOpen}
          onClose={onCloseRegister}
          onOpenLogin={onOpenLogin}
          onLoginSuccess={onLoginSuccess}
        />
      )}
    </AnimatePresence>
  );
};
